//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { rec } from "@/lang/zh";
import publicRoute from "./component/publicRoute";
import ToDo from "./component/ToDo.vue";
export default {
  extends: publicRoute,
  name: "applicationList",
  components: {
    ToDo,
  },
  data() {
    return {
      loadRouter: "/portal/applicationList/applicationLoad",
      progressList: [],
      pastList: [],
      interviewList: [],
      showNoData: false,
      isShowReason: false,
      temp: "",
      rowArray: [],
      dsj1: null,
    };
  },
  methods: {
    mouseMove(event) {
      var e = event || window.event;
      var scrollx =
        document.documentElement.scrollLeft || document.body.scrollTop;
      var scrolly =
        document.documentElement.scrollTop || document.body.scrollTop;
      var x = e.pageX || e.clientX + scrollx;
      var y = e.pageY || e.clientY + scrolly;
      console.log("x", x);
      console.log("y", y);
    },
    getInfo() {
      this.rowArray = [];
      this.pastList = [];
      this.progressList = [];
      this.interviewList = [];
      let params = {};
      let uuidApi = "api/api/findApplicationInfoList";
      this.axios
        .post(uuidApi, params)
        .then(({ data }) => {
          if (data.code == "1") {
            this.showNoData = true;
            let record = data.data.record.application;
            this.interviewList = data.data.record.interview;
            if (record.length > 0) {
              for (let i = 0; i < record.length; i++) {
                let status = record[i].status;
                if (status == "0" || status == "2" || status == "3" || status == "4") {
                  this.pastList.push(record[i]);
                } else if (status == "1") {
                  this.progressList.push(record[i]);
                }
              }
            }
          }
        })
        .catch((error) => console.log(error));
    },
    doRowEdit(uuid) {
      this.$router.push({
        path: this.loadRouter,
        query: {
          uuid: uuid,
        },
      });
    },

    isShow(uuid) {
      if (this.rowArray.indexOf(uuid) > -1) {
        return true;
      }
      return false;
    },

    async changeShowReason(value, uuid) {
      if ("1" == value) {
        if (this.rowArray.length == 0 || this.rowArray.indexOf(uuid) == -1) {
          this.rowArray.push(uuid);
        }
        // this.isShowReason = true;
      } else {
        if (this.rowArray.indexOf(uuid) > -1) {
          let k = this.rowArray.indexOf(uuid);
          this.rowArray.splice(k, 1);
        }
        // this.isShowReason = false;
      }
    },
    async updateInterview(item, value) {
      let params = {};
      let url = "api/api/updateInterview";
      let reason = item.reason;
      let str = "";
      if ("1" == value) {
        params.status = "accept";
        str = "Are you sure to accept the schedule?";
      } else {
        params.status = "reject";
        if (!this.isNotNullOrEmpty(reason)) {
          this.$msgDailog.showMsgBox({
            title: "Please fill out the reason",
          });
          return;
        }
        params.reason = reason;
        str = "Are you sure to reassess the schedule?";
      }
      params.uuid = item.uuid;
      let flag = await this.tipCustomConfirmNew("default", str, "").then(
        (res) => {
          return res;
        }
      );
      if (flag) {
        this.axios.post(url, params).then(({ data }) => {
          if (data.code == "1") {
            this.getInfo();
          }
        });
      }
    },
  },
  created() {
    this.getInfo();
  },
};



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/portal/applicationList.vue